import store from '@/store'

export default function settingsService() {
  // Getters
  const getSettings = () => store.getters['settings/getSettings']
  const getLoading = () => store.getters['settings/getLoading']
  const getLoaded = () => store.getters['settings/getLoaded']
  const getError = () => store.getters['settings/getError']
  const getSetting = (key, defaultValue = null) => store.getters['settings/getSetting'](key, defaultValue)
  const canBook = () => store.getters['settings/canBook']
  const bookingEnabled = () => store.getters['settings/getBookingEnabled']

  // Actions
  const fetchSettings = (group = null) => store.dispatch('settings/fetchSettings', group)

  const fetchSetting = (key, defaultValue = null) => store.dispatch('settings/fetchSetting', { key, defaultValue })

  return {
    // Getters
    getSettings,
    getLoading,
    getLoaded,
    getError,
    getSetting,
    canBook,
    bookingEnabled,

    // Actions
    fetchSettings,
    fetchSetting,
  }
}
